import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { withApollo } from '@hocs'
import { useRecentProducts } from '@velasca/hooks/use-recent-products'

const recentProductTracker = document.querySelector('#recent-product-tracker')
const recentProductID = recentProductTracker?.getAttribute('data-product-id')

const RecentProductTrackerApp = ({ productID }: { productID: string }) => {
  // TODO: this is a really bad pattern. In fact I need to pass skip: true to AVOID making an unnecessary fetch request.
  // Better pattern: create a trackRecent function and call it when needed. Update: the hook already has a setRecentProduct
  // that does exactly what shown below.
  // const { trackRecent } = useRecentProducts()
  // useEffect(() => {
  //   trackRecent(productId)
  // }, [])
  // Another way of doing it would be separating tracking hook from fetching hook. They are two different and loosely related features.
  // const { trackRecent } = useRecentProductTracker()
  // same as above
  // const { recentProducts, loading, error } = useRecentProducts()
  useRecentProducts({ productId: productID, skip: true })

  return null
}

const RecentProductTrackerAppWrapper = pipe(RecentProductTrackerApp, withApollo)

export const renderRecentProductTrackerApp = () => {
  if (recentProductTracker && recentProductID) {
    ReactDOM.createRoot(recentProductTracker).render(
      <RecentProductTrackerAppWrapper productID={recentProductID} />,
    )
  }
}
